<script setup>
import { useAppState } from '../store/ocg-app-state';

defineProps({
  marginBot: { type: Number, default: 10 },
  marginRight: { type: Number, default: 15 },
});

const appState = useAppState();
const appVersion = appState.appVersionText;
</script>

<template>
  <div
    class="version-container"
    :style="{ bottom: `${marginBot}px`, right: `${marginRight}px` }"
  >
    <p class="version">
      {{ appVersion }}
    </p>
  </div>
</template>

<style scoped>
.version-container {
  position: absolute;
  bottom: 10px;
  right: 15px;
}

.version {
  color: var(--md-on-surface);
}
</style>
